import { DatePickerBaseServant } from './../servants/date_picker_base_servant';
import { DatePickerDefaultServant } from '../servants/date_picker_default_servant';
import { DatePickerSchedulingServant } from '../servants/date_picker_scheduling_servant';
import { IWeekDay, IDay } from './../date_picker_interface';
import * as _4 from 'lodash4';

class DatePickerDefinition implements ng.IComponentOptions {
  public bindings: any = {
    timings: '<',
    selectedDay: '<',
    selectedTime: '<',
    showTimeMenu: '<',
    defaultDatePicker: '<',
    onSelect: '&',
    onNextweekSelection: '&',
    onPreviousweekSelection: '&',
    thirdSize: '<'
  };
  public templateUrl: string = 'ui-ng-mobile-date-picker/src/components/date_picker.html';
  public controller: string = 'datePickerController';
}

export class DatePicker {
  timings: Array<string>;
  selectedDay: IWeekDay;
  selectedTime: IDay;
  showTimeMenu: boolean;
  defaultDatePicker: boolean;
  onSelect: Function;
  onNextweekSelection: Function;
  onPreviousweekSelection: Function;
  thirdSize: boolean;

  servant: DatePickerSchedulingServant | DatePickerDefaultServant;
  timingArray: Array<IDay>;
  week: Array<IWeekDay>;
  previous_week_firstdate: moment.Moment;
  current_week_lastdate: moment.Moment;

  constructor(
    private ngDatePickerSchedulingServant: DatePickerSchedulingServant,
    private ngDatePickerDefaultServant: DatePickerDefaultServant
  ) {}

  $onInit(): void {
    this.defaultDatePicker = _4.isUndefined(this.defaultDatePicker) ? true : this.defaultDatePicker;
    this.showTimeMenu = _4.isUndefined(this.showTimeMenu) ? true : this.showTimeMenu;
    this.servant = !this.defaultDatePicker ? this.ngDatePickerSchedulingServant : this.ngDatePickerDefaultServant;
    this.timingArray = this.servant.constructDates(this.timings);
    this.week = this.servant.getWeek(this.servant.getWeekStartDate(this.timingArray), this);
    this.thirdSize = !_4.isUndefined(this.thirdSize);
    this.servant.initialize(this);

    if (_4.isEmpty(this.selectedDay)) {
      this.resetSelectedDay();
    }
  }

  selectDayOfWeek(day: IWeekDay): void {
    this.selectedDay = day;
    this.resetTimeSelection();
    this.servant.selectionChange(this.selectedDay, this.selectedTime);
  }

  selectTime(time: IDay): void {
    time.selected = !time.selected;
    _4.forEach(_4.filter(this.timingArray, { selected: true }), (currentTime) => {
      currentTime.selected = currentTime !== time ? false : currentTime.selected;
    });
    this.selectedTime = _4.first(_4.filter(this.timingArray, { selected: true }));
    this.servant.selectionChange(this.selectedDay, this.selectedTime);
  }

  hasAvailableTimes(day: IWeekDay): boolean {
    return _4.size(this.servant.getAvailableTimes(this.timingArray, day)) > 0 || this.defaultDatePicker;
  }

  isPreviousWeekEnabled(): boolean {
    return !_4.first(this.week).date.isBefore(moment());
  }

  hasNoSelectedTime(): boolean {
    return _4.isEmpty(this.selectedTime);
  }

  hasSelectedTime(time: IDay): boolean {
    return this.servant.hasSelectedTime(time, this.selectedTime);
  }

  hasSelectedDay(): boolean {
    return !_4.isEmpty(this.selectedDay) && !_4.isUndefined(this.selectedDay.day_week);
  }

  public resetOnSelectionChange(preserveSelections?: boolean) {
    if (!preserveSelections) {
      this.resetSelectedDay();
      this.resetTimeSelection();
    }
  }

  private resetSelectedDay(): void {
    this.selectedDay = {} as IWeekDay;
    this.selectedTime = {} as IDay;
  }

  private resetTimeSelection(): void {
    if (!_4.isEmpty(this.selectedTime)) {
      _4.first(_4.filter(this.timingArray, { selected: true })).selected = false;
      this.selectedTime = {} as IDay;
    }
    this.servant.selectionChange(this.selectedDay, this.selectedTime);
  }
}
angular
  .module('ui-ng-mobile-date-picker')
  .controller('datePickerController', DatePicker)
  .component('datePicker', new DatePickerDefinition());



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-mobile-date-picker/src/components/date_picker_controller.ts